Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var cn = require('classnames');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"grid-gap":"gap__gap_1l3yx","gap":"gap__gap_1l3yx","vertical":"gap__vertical_1l3yx","horizontal":"gap__horizontal_1l3yx"};
require('./index.css');

var SIZE_TO_CLASSNAME_MAP = {
    '3xs': 'size-2',
    '2xs': 'size-4',
    xs: 'size-8',
    s: 'size-12',
    m: 'size-16',
    l: 'size-20',
    xl: 'size-24',
    '2xl': 'size-32',
    '3xl': 'size-40',
    '4xl': 'size-48',
    '5xl': 'size-64',
    '6xl': 'size-72',
    '7xl': 'size-96',
    '8xl': 'size-128',
    0: 'size-0',
    1: 'size-1',
    2: 'size-2',
    4: 'size-4',
    8: 'size-8',
    12: 'size-12',
    16: 'size-16',
    20: 'size-20',
    24: 'size-24',
    26: 'size-26',
    28: 'size-28',
    32: 'size-32',
    40: 'size-40',
    48: 'size-48',
    64: 'size-64',
    72: 'size-72',
    96: 'size-96',
    128: 'size-128',
    256: 'size-256',
};
var Gap = function (_a) {
    var size = _a.size, _b = _a.direction, direction = _b === void 0 ? 'vertical' : _b, _c = _a.tag, Component = _c === void 0 ? 'div' : _c, className = _a.className, dataTestId = _a.dataTestId;
    return (React__default.default.createElement(Component, { "data-test-id": dataTestId, "data-gap-size": SIZE_TO_CLASSNAME_MAP[size], className: cn__default.default(styles.gap, styles[direction], className) }));
};

exports.Gap = Gap;
